import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isEzModalStatus: false,
    ez_page_load : false,
    subdomain_id : null,
    user_id : null,
    directory_id: null,
};

const ezleadzSlice = createSlice({
    name: "ezleadz",
    initialState,
    reducers: {
        setEzModalStatus(state,action){
            state.isEzModalStatus = action.payload.status;
        },
        setEzpageLoad(state, action) {
            state.ez_page_load = action.payload.editor_page_load;
        },
        setEzData(state,action){
            state.subdomain_id = action.payload.sid;
            state.user_id = action.payload.user_id;
            state.directory_id = action.payload.directory_id;
        }

    }
})

export const ezleadzActions = ezleadzSlice.actions;
export default ezleadzSlice.reducer;